/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page_banner[_ngcontent-%COMP%]{background:url(/assets/images/campanha.jpg) center center no-repeat #333;position:relative}\n/*# sourceMappingURL=gestao-de-campanhas.component.css.map*/"];
export { styles as styles };
